import { render, staticRenderFns } from "./RecruitTranslate.vue?vue&type=template&id=15a09b05"
import script from "./RecruitTranslate.vue?vue&type=script&lang=js"
export * from "./RecruitTranslate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports